import { FIFTEEN_SECONDS_IN_MS, MILLISECONDS_PER_SECOND, TWO_MINUTES_IN_MS } from "@/constants";

const HTTP_TOO_MANY_REQUESTS = 429;
const HTTP_SERVER_ERROR_MIN = 500;
const HTTP_SERVER_ERROR_MAX = 599;

/**
 * Global configuration for the polling client
 */
export const POLLING_CONFIG = {
  MAX_WAIT_MS: TWO_MINUTES_IN_MS, // 2 minutes
  BASE_DELAY_MS: MILLISECONDS_PER_SECOND, // 1 second
  MAX_DELAY_MS: FIFTEEN_SECONDS_IN_MS, // 15 seconds
} as const;

/**
 * Centralized HTTP status constants
 * Used across all services for consistency
 */
export const HTTP_STATUS = {
  TOO_MANY_REQUESTS: HTTP_TOO_MANY_REQUESTS,
  INTERNAL_SERVER_ERROR_MIN: HTTP_SERVER_ERROR_MIN,
  INTERNAL_SERVER_ERROR_MAX: HTTP_SERVER_ERROR_MAX,
} as const;
